var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("h1", {
    staticClass: "landing-title",
    class: [
      `landing-title_size_${_vm.size}`,
      { "landing-title_uppercase": _vm.uppercase },
    ],
    style: _vm.customStyles,
    attrs: { "data-typo-type": "title" },
    domProps: { innerHTML: _vm._s(_vm.title) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }